import styled from "styled-components";

const StyledAvatarGroup = styled.div`
	display: flex;
	gap: 3px;
	width: fit-content;
`;

export default StyledAvatarGroup;
